import React from 'react';
import { IoIosArrowDroprightCircle } from 'react-icons/io';
import theme from '../../styles/themes/default';
import { StyledButton } from '../StyledButton';

import { ButtonWrapper, Container } from './style';
import { SiGooglesheets } from 'react-icons/si';

interface IProps {
  cancelText?: string,
  confirmText?: string,
  onCancel?: () => void,
  onConfirm?: () => void,
  isConfirmDisabled?: boolean,
  templateUrl: string,
}

export const ImportVehicleActions = ({
  cancelText = "Cancelar",
  confirmText = "Enviar",
  onCancel = () => {},
  onConfirm = () => {},
  isConfirmDisabled,
  templateUrl
}: IProps) => (
  <Container>
    <ButtonWrapper>
      <StyledButton
        text='Baixar template'
        icon={<SiGooglesheets size={24}/>}
        iconPosition='left'
        fullWidth
        onClick={() => {
          window.open(templateUrl, '_blank');
        }}
      />
    </ButtonWrapper>
    <ButtonWrapper>
      <StyledButton
        backgroundColor='white'
        text={cancelText}
        color={theme.colors.gray[600]}
        border={`1px solid ${theme.colors.gray[600]}`}
        onClick={onCancel}
        fullWidth
        type="button"
      />
    </ButtonWrapper>
    <ButtonWrapper>
      <StyledButton
        text={confirmText}
        fullWidth
        icon={
          <IoIosArrowDroprightCircle size={18}/>
        }
        iconPosition="right"
        onClick={onConfirm}
        type="submit"
        disabled={isConfirmDisabled}
      />
    </ButtonWrapper>
  </Container>
);
